const BIRD_SVG = `<img src="/logo.png" alt="" class="nav-logo" />`;

export interface NavOptions {
  active: 'landing' | 'firehose' | 'frequencies' | 'docs' | 'faq';
}

export function renderNav(opts: NavOptions): string {
  const link = (href: string, label: string, key: NavOptions['active']) =>
    `<a class="nav-link${opts.active === key ? ' active' : ''}" href="${href}">${label}</a>`;

  return `
    <nav class="nav" aria-label="primary">
      <a class="nav-brand" href="#/">
        ${BIRD_SVG}
        <span>The Flock</span>
      </a>
      <div class="nav-links">
        ${link('#/firehose', 'watch', 'firehose')}
        ${link('#/frequencies', 'my frequencies', 'frequencies')}
        ${link('#/docs', 'docs', 'docs')}
        ${link('#/faq', 'faq', 'faq')}
        <span class="nav-live" aria-hidden="true">live</span>
      </div>
    </nav>
  `;
}
